<template>
  <div class="seller">
    <shopHeader v-if="showTitle" />
    <div class="clear pad30_b" :class="{ w1200: showTitle }">
      <sellerMenu class="float-left mar20_r" v-if="showTitle" />
      <div :class="{ seller_main: showTitle }">
        <router-view />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>
<script>
import { mapState } from "vuex";
import sellerMenu from "@/components/sellerMenu";
import shopHeader from "@/components/shopHeader";

export default {
  name: "seller",
  components: {
    shopHeader,
    sellerMenu,
  },
  data() {
    return {};
  },
  computed: mapState({
    showTitle: (state) => state.app.showTitle,
  }),
  created() {
    const { isShowTitle } = this.$route.query;
    this.$store.dispatch("header/getIsShowShopHead", { isShowTitle: isShowTitle && isShowTitle === "1" ? "1" : "" }).then((res) => {
      this.$store.commit("app/setShowTitle", res);
    });

    if (isShowTitle && isShowTitle === "1") {
      this.$store.commit("app/setShowTitle", false);
    }
  },
};
</script>
